var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-cell",class:{
    'table-cell__focus': _vm.inFocus,
    'table-cell__disabled': _vm.disabled
  }},[_vm._t("default",function(){return [_c('label',{staticClass:"content-wrapper",attrs:{"for":_vm.id}},[(_vm.prefix)?_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),(_vm.currency)?_c('InputCurrency',{attrs:{"value":_vm.value,"id":_vm.id,"placeholder":_vm.placeholder,"options":_vm.max != null && _vm.min != null
            ? {
                currency: _vm.getCurrency,
                valueRange: {
                  min: _vm.min,
                  max: _vm.max
                }
              }
            : {
                currency: _vm.getCurrency
              },"autocomplete":"off"},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"focus":function($event){return _vm.$emit('focus', $event)}}}):_c('input',{attrs:{"id":_vm.id,"type":_vm.type,"placeholder":_vm.placeholder,"autocomplete":"off","min":"0"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.currentTarget.value)},"focus":function($event){_vm.inFocus = true
          $event.target.select()},"blur":function($event){_vm.inFocus = false}}}),(_vm.sufix)?_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.sufix))]):_vm._e()],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }